export default __webpack_public_path__ + "static/media/arm-right-back.92ba7407.png";